import { render, staticRenderFns } from "./BudgetRestrictionsTable.vue?vue&type=template&id=4e729552&"
import script from "./BudgetRestrictionsTable.vue?vue&type=script&lang=js&"
export * from "./BudgetRestrictionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports